import React from 'react'
import { playPath } from '@/lib/utils'
import { IDownloadType, ILocation } from '@/lib/enums/device'
import { eventLogProducer } from '@/lib/event-logger'
import { Action } from '@@/action_pb'
import Image from 'next/image'
import { shimmer, toBase64 } from '@/lib/utils'
import styled from 'styled-components'
import LazyLoad from 'react-lazyload'

type IProps = {
  location: ILocation
  isMobile: boolean
  width?: number
}

const IosDownloadBtn = (props: IProps) => {
  const goToDown = (href: string) => {
    eventLogProducer.push({
      action: Action.GETITONAPPGALLERYBUTTONCLICK,
    })
    setTimeout(() => {
      window.location.href = href
    }, 1000)
  }

  return (
    <Wrapper width={props?.width}>
      <section className="banner goto" onClick={() => goToDown(playPath(IDownloadType.IOS, '', props.location))}>
        {!props.isMobile && (
          <LazyLoad>
            <img
              className="qrcode"
              src={`/images/qrcode/qr-ios-code-${props.location?.toLocaleLowerCase()}.png`}
              alt="qrcode"
            />
          </LazyLoad>
        )}
        <LazyLoad>
          <Image
            src={`/images/qrcode/${props?.isMobile ? 'qr_ios_download_mb.png' : 'qr_ios_download.png'}`}
            alt="ios_download"
            width={!props.isMobile ? (props?.width ? 144 : 217) : 130}
            height={!props.isMobile ? (props?.width ? 44 : 66) : 41}
            quality={85}
            placeholder={props.isMobile ? 'empty' : 'blur'}
            blurDataURL={props.isMobile ? '' : `data:image/svg+xml;base64,${toBase64(shimmer(217, 66))}`}
          />
        </LazyLoad>
      </section>
    </Wrapper>
  )
}

export default IosDownloadBtn

const Wrapper = styled.div<{ width: number }>`
  .goto {
    cursor: pointer;
  }
  .banner {
    position: relative;
    box-sizing: border-box;
    .qrcode {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .banner:hover .qrcode {
    top: ${(props) => `${props.width ? '100px' : '140px'}`};
    width: ${(props) => `${props.width ? '120px' : '160px'}`};
    height: ${(props) => `${props.width ? '120px' : '160px'}`};
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid #f5f5f5;
    opacity: 1;
    z-index: 3;
  }
`
